import { render, staticRenderFns } from "./diadiem.vue?vue&type=template&id=b82082d8"
import script from "./diadiem.vue?vue&type=script&lang=js"
export * from "./diadiem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports